import type { AiChatDataPart } from '@percent/domain/ai-chat'
import { InsightsAiMetricResult } from '@percent/partner-dashboard/services/insightsAi/insightsAiService.types'
import { InsightsAiResult } from './InsightsAiResult'
import classes from './InsightsAiResults.module.scss'

/**
 * The insights `renderData` for the ai-chat answer: picks the agent's `metric` data
 * parts out of a turn and renders each via the shared insights chart, as a row of
 * cards. Generic ai-chat knows nothing about metrics — this is the insights binding.
 */
export function InsightsAiResults({ data }: Readonly<{ data: readonly AiChatDataPart[] }>) {
  const metrics = data
    .filter(part => part.name === 'metric')
    .map(part => part.data as InsightsAiMetricResult)
    // suggestedChart 'none' means the value is already in the prose — draw no card.
    .filter(metric => metric.metricData.suggestedChart !== 'none')

  if (metrics.length === 0) return null

  return (
    <div className={classes.results} data-testid="insights-ai-results">
      {metrics.map(result => (
        <InsightsAiResult key={result.ref} result={result} />
      ))}
    </div>
  )
}
